module.exports = __webpack_public_path__ + "static/media/18.c8aa853d.svg";